/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { getAuthCookies } from 'lorautils/cookies/auth';

export default function () {
  let authState = { authed: false, status: 'idle' };
  const auth = getAuthCookies();
  if (auth) {
    authState = { authed: true, ...auth, status: 'cookies' };
  }
  return authState;
}




// WEBPACK FOOTER //
// ./src/redux/store/authState.js